import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import AboutSnippet from './components/AboutSnippet';
import EcosystemSection from './components/EcosystemSection';
import PartnersSection from './components/PartnersSection';
import CTABanner from './components/CTABanner';

const Home = () => {
  return (
    <div className="font-jakarta">
      <Navbar />
      <main>
        <Hero />
        <AboutSnippet />
        <EcosystemSection />
        <PartnersSection />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
